import React, {useEffect, useState} from 'react'

const ClientMoreInfos = (props) => {
  const {
    clientData,
    demandeId,
    contactedBy,
    setContactedBy,
    demandeClient,
    contentCommunication,
    otherData,
    radioValue,
    isConfirmEdit,
    contactedByBloc,
    setContactedByBloc,
    fromListDemande = false,
    groupeClientLoader = false,
    showMoreClientInfo,
    setShowMoreClientInfo
  } = props

  useEffect(() => {
    if (setContactedByBloc) {
      if (contentCommunication == "" || contentCommunication == null) {
        setContactedByBloc(demandeClient?.communication)
      } else {
        setContactedByBloc(contentCommunication)
      }
    }
    if (setContactedBy && demandeClient?.contactedBy) {
      setContactedBy(demandeClient.contactedBy)
    }
  }, [demandeClient, contentCommunication])

  const displayContacedBy = () => {
    if (contentCommunication != "" && contentCommunication != null) {
      if (radioValue === 'appel') {
        return <span>par téléphone ({contactedByBloc}) </span>
      } else if (radioValue === 'sms') {
        return <span>par sms ({contactedByBloc}) </span>
      } else if (radioValue === 'email') {
        return <span>par email ({contactedByBloc}) </span>
      }
    } else {
      if (demandeClient?.appel) {
        return <span>par téléphone ({contactedByBloc}) </span>
      } else if (demandeClient?.sms) {
        return <span>par sms ({contactedByBloc}) </span>
      } else if (demandeClient?.email) {
        return <span>par email ({contactedByBloc}) </span>
      }
    }
  }

  // Affichage toggle "Plus d'info"
  const moreInfoSwitcher = () => {
    return (
      showMoreClientInfo ? (
          <div className='d-flex align-items-center gap-2'>
            <i className='ki-duotone ki-up'></i>
          </div>
        ) : (
          <div className='d-flex align-items-center gap-2'>
            <i className='ki-duotone ki-down'></i>
          </div>
        )
    )
  }



  return (
    <div className={'px-5'}>
      <span
        className='d-flex align-items-center mb-1'
        onClick={() => {
          !groupeClientLoader && setShowMoreClientInfo?.(!showMoreClientInfo)
        }}
      >
        <hr className='flex-grow-1 text-muted' />
        <div
          className={`d-flex gap-2 text-primary fw-bold fs-6 mx-3 
          ${!groupeClientLoader && 'cursor-pointer'} align-items-center`}
        >
          Plus d'informations{' '}
          {fromListDemande ? (
            groupeClientLoader ? (
              <span className='spinner-border spinner-border-sm align-middle w-13px h-13px'></span>
            ) : (
              moreInfoSwitcher()
            )
          ) : (
            moreInfoSwitcher()
          )}
        </div>
        <hr className='flex-grow-1 text-muted' />
      </span>

      {showMoreClientInfo && (
        <div>
          <div className='d-flex justify-content-between mb-2 flex-column flex-lg-row'>
            {/*debut bloc 1*/}
            <div className='d-flex flex-column gap-2'>
              <div className='d-flex gap-3'>
                <span className='text-gray-400'>En compte : </span>
                <span>En compte</span>
              </div>
              <div className='d-flex gap-3'>
                <span className='text-gray-400'>Groupe client : </span>
                <span>{clientData?.group}</span>
              </div>
              <div className='d-flex gap-3'>
                <span className='text-gray-400'>Taux de remise : </span>
                <span>{clientData?.tauxRemise ? `-${clientData.tauxRemise}%` : ''}</span>
              </div>
              <div className='d-flex gap-3'>
                <span className='text-gray-400'>Frais de port: </span>
                <span>
                  {clientData?.fraisPortOffert ? 'offert' : !clientData?.group ? '' : 'non offert'}
                </span>
              </div>
            </div>
            {/*fin bloc 1*/}

            {/*debut bloc 2 : information client contact*/}
            <div className='d-flex flex-column gap-2'>
              <div className='d-flex gap-3'>
                <span className='text-gray-400'>Contact demande : </span>
                {displayContacedBy()}
              </div>
              <div className='border' style={{padding: '10px', borderRadius: '12px'}}>
                <div className='d-flex justify-content-between gap-5 flex-column flex-md-row'>
                  <div className='d-flex gap-3'>
                    <div className='d-flex flex-column gap-2'>
                      <span className='text-gray-400'>Nom :</span>
                      <span className='text-gray-400'>Mobile :</span>
                      <span className='text-gray-400'>Email :</span>
                    </div>
                    <div className='d-flex flex-column gap-2'>
                      <span className='min-h-20px'>
                        {demandeId == null
                          ? contactedBy?.nom ?? ''
                          : isConfirmEdit
                          ? contactedBy?.nom
                          : otherData?.contactedBy?.nom}
                      </span>
                      <span className='min-h-20px'>
                        {' '}
                        {demandeId == null
                          ? contactedBy?.mobile ?? ''
                          : isConfirmEdit
                          ? contactedBy?.mobile
                          : otherData?.contactedBy?.mobile}
                      </span>
                      <span className='min-h-20px'>
                        {' '}
                        {demandeId == null
                          ? contactedBy?.email
                          : isConfirmEdit
                          ? contactedBy?.email
                          : otherData?.contactedBy?.email}
                      </span>
                    </div>{' '}
                  </div>
                  <div className='d-flex gap-3'>
                    <div className='d-flex flex-column gap-2'>
                      <span className='text-gray-400'>Prénom :</span>
                      <span className='text-gray-400'>Tel :</span>
                    </div>
                    <div className={'d-flex flex-column gap-2'}>
                      <span className='min-h-20px'>
                        {demandeId == null
                          ? contactedBy?.prenom ?? ''
                          : isConfirmEdit
                          ? contactedBy?.prenom
                          : otherData?.contactedBy?.prenom}
                      </span>
                      <span className='min-h-20px'>
                        {demandeId == null
                          ? contactedBy?.telephone ?? ''
                          : isConfirmEdit
                          ? contactedBy?.telephone
                          : otherData?.contactedBy?.telephone}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*debut bloc 3*/}
            <div className='d-flex flex-column gap-2'>
              <div className='d-flex gap-3'>
                <span className='text-gray-400'>Code client: </span>
                <span>{clientData?.id}</span>
              </div>
              <div className='d-flex gap-3'>
                <span className='text-gray-400'>SIRET: </span>
                <span>{demandeId == null ? clientData?.siren : clientData?.siren}</span>
              </div>
              {clientData?.codeClientAIndus && (
                <div className='d-flex gap-3'>
                  <span className='text-gray-400'>Code industrie: </span>
                  <span>{clientData?.codeClientAIndus}</span>
                </div>
              )}
              {clientData?.codeClientAAuto && (
                <div className='d-flex gap-3'>
                  <span className='text-gray-400'>Code auto: </span>
                  <span>{clientData?.codeClientAAuto}</span>
                </div>
              )}
              {clientData?.codeClientAMoto && (
                <div className='d-flex gap-3'>
                  <span className='text-gray-400'>Code moto: </span>
                  <span>{clientData?.codeClientAMoto}</span>
                </div>
              )}
            </div>
            {/*fin bloc 3*/}
          </div>
        </div>
      )}
    </div>
  )
}

export default ClientMoreInfos